import { fireLoginHandlers } from '../../utils/loginHandlers';
import { trackRegistrationComplete } from './authTracking';
import { setTokens, updateProfile } from './userStorageActions';

export function authTrackingHandler({ userRegistration, ga, environment }) {
    trackRegistrationComplete({ ...userRegistration, ...ga });

    setTokens({
        environment,
        ...userRegistration,
    });

    updateProfile({ environment, ...userRegistration }).then(() => {
        fireLoginHandlers(userRegistration);
    });
}
